module.exports = __webpack_public_path__ + "static/anissa-672f913b13ec5102abdfa2e259ac2a9c.jpg";